export const APP_THEME_STORAGE_KEY = 'hedger-ui-theme';
export const APP_THEME_EVENT = 'hedger-ui-theme-change';
export const VITEPRESS_THEME_STORAGE_KEY = 'vitepress-theme-appearance';

export const getStoredAppTheme = () => {
  if (typeof window === 'undefined') {
    return 'dark';
  }

  const stored = window.localStorage?.getItem(APP_THEME_STORAGE_KEY);
  if (stored === 'light' || stored === 'dark') {
    return stored;
  }

  const guideStored = window.localStorage?.getItem(VITEPRESS_THEME_STORAGE_KEY);
  return guideStored === 'light' ? 'light' : 'dark';
};

export const applyAppTheme = (theme) => {
  if (typeof document === 'undefined') {
    return;
  }

  const nextTheme = theme === 'light' ? 'light' : 'dark';
  document.documentElement.classList.toggle('app-light', nextTheme === 'light');
  document.documentElement.classList.toggle('app-dark', nextTheme === 'dark');
  document.documentElement.dataset.appTheme = nextTheme;
};

export const setStoredAppTheme = (theme) => {
  const nextTheme = theme === 'light' ? 'light' : 'dark';

  if (typeof window !== 'undefined') {
    window.localStorage?.setItem(APP_THEME_STORAGE_KEY, nextTheme);
    window.localStorage?.setItem(VITEPRESS_THEME_STORAGE_KEY, nextTheme);
  }

  applyAppTheme(nextTheme);

  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(APP_THEME_EVENT, { detail: { theme: nextTheme } }));
  }
};
